import { Z } from "@repo/core/utils/zod.utils";

export enum BIOMETRICS_FLOW {
  AUTHENTICATION = "Autenticação",
  SDK = "SDK",
  CREATE_PROCESS = "Criação do Processo",
  PROCESS_RESULT = "Resultado do Processo",
  GET_USER_SELFIE = "Obtenção Selfie Usuário",
  /** Único platform flow: "Obter Selfie do Cliente" (API expects literal `SELFIE`) */
  SELFIE = "SELFIE"
}

const biometricsRegisterConsultationSchema = Z.object({
  lngProposta: Z.number(),
  strTipoDeFluxo: Z.nativeEnum(BIOMETRICS_FLOW),
  strRetorno: Z.any(),
  strNumeroDocumento: Z.string().optional()
});

export type BiometricsRegisterDTO = Z.infer<
  typeof biometricsRegisterConsultationSchema
>;
